/**
 * Design tokens ported from the new aidocr UI prototype.
 * These form the visual foundation for the refreshed design system.
 */

export const C = {
    navy: "#3D4B7D",
    navyDark: "#333B4F",
    navyHover: "#536498",
    periwinkle: "#A8B5D9",
    amber: "#E09A1E",
    teal: "#4DAF9F",
    coral: "#D4694F",
    offWhite: "#EBEEF2",
    lightGray: "#E0E3E8",
    medGray: "#8E95A3",
    white: "#FFFFFF",
    black: "#000000",
    sidebarBg: "#ffffff",
    pageBg: "#f1f1f1",
} as const

export type DesignColor = keyof typeof C

/** Source-type accent colours */
export const srcColor: Record<string, string> = {
    PDF: C.coral,
    BIM: C.teal,
    Excel: C.teal,
    IoT: C.amber,
    DOC: C.navy,
    PPT: C.amber,
    XLS: C.teal,
    SQL: C.periwinkle,
    EML: C.navy,
    Email: C.navy,
    Image: C.amber,
    CAD: "#9B59B6",
}

/** Common border radius values used in the new design system */
export const radius = {
    sm: 4,
    md: 8,
    lg: 12,
    xl: 14,
} as const

/** Common box-shadow values */
export const shadow = {
    sm: "0 2px 8px rgba(0,0,0,0.06)",
    md: "0 4px 16px rgba(0,0,0,0.1)",
    lg: "0 8px 32px rgba(0,0,0,0.12)",
} as const

/** Standard transition for interactive elements */
export const transition = {
    fast: "all 0.15s ease",
    normal: "all 0.2s ease",
} as const
